import { Image, publicAssetUrl } from '@wilkins-software/redwood-utils';

const logoUrl = publicAssetUrl('images/logo.png');

export function LogoLink() {
  return (
    <a className="navbar-brand relative z-[70] md:me-8" href="/">
      {/* Shared Image rather than a raw element: Cloudflare Transformations
          resize the 710px source down to what this 40px slot actually needs.
          Never re-encode the committed asset to do that. */}
      <Image
        src={logoUrl}
        alt="Wilkins Software Inc."
        width={40}
        height={40}
        priority
        className="inline-block max-w-10"
      />
    </a>
  );
}
